export default "__VITE_ASSET__x_Xv4qx1__"